import { render, staticRenderFns } from "./PropertyInfo.vue?vue&type=template&id=00857232&scoped=true"
import script from "./PropertyInfo.vue?vue&type=script&lang=js"
export * from "./PropertyInfo.vue?vue&type=script&lang=js"
import style0 from "./PropertyInfo.vue?vue&type=style&index=0&id=00857232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00857232",
  null
  
)

export default component.exports